module.exports = __webpack_public_path__ + "static/congratulations-38d52f5a47c4e1273e39383705a4f956.png";